import { render, staticRenderFns } from "./SegurDoc.vue?vue&type=template&id=76be28d8&scoped=true"
import script from "./SegurDoc.vue?vue&type=script&lang=js"
export * from "./SegurDoc.vue?vue&type=script&lang=js"
import style0 from "./SegurDoc.vue?vue&type=style&index=0&id=76be28d8&prod&scoped=true&lang=css"
import style1 from "./SegurDoc.vue?vue&type=style&index=1&id=76be28d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be28d8",
  null
  
)

export default component.exports